import { Colors, Img, Lightning, Utils } from '@lightningjs/sdk'
// import MovingTitle from "../MovingTitle";

export default class GridPageCover extends Lightning.Component {
  static _template() {
    return {
      w: 420,
      h: 541,
      CoverWrapper: {
        w: 420,
        h: 420,
        pivotX: 0.5,
        pivotY: 1,
        // CoverShadow: {w: 440, h: 440, texture: Lightning.Tools.getShadowRect(440, 440, 5, 17, 19), color: Colors('black').alpha(0.2).get()}, // TODO alpha - 0.01
        CoverImageWrapper: {
          w: 420,
          h: 420,
          shader: {
            radius: 5,
            stroke: 5,
            strokeColor: Colors('border')
              .alpha(0)
              .get(),
            fill: false,
            type: Lightning.shaders.RoundedRectangle,
          },
          // CoverBG: {w: 420, h: 420, src: Utils.asset('images/covers/ImagePlaceHolder.jpg'), alpha: 0},
          Cover: {
            w: 420,
            h: 420,
            src: Utils.asset('images/covers/ImagePlaceHolder.jpg'),
          },
        },
      },
      Title: {
        w: 420,
        h: 55,
        x: 5,
        y: 430,
        color: Colors('white').get(),
        alpha: 1,
        text: {
          text: '',
          fontSize: 25,
          verticalAlign: 'middle',
          fontFace: 'OpenSansRegular',
          lineHeight: 35,
          maxLines: 1,
          wordWrapWidth: 420,
          textOverflow: 'ellipsis',
        },
      },
      // MovingTitle: {w: 440, h: 55, x: -5, y: 430, type: MovingTitle, fontSize: {sz: 30}, fontFace: 'OpenSansBold', alpha: 0.001},
      SubTitle: {
        w: 420,
        h: 55,
        x: 5,
        y: 470,
        color: Colors('white').get(),
        text: {
          text: '',
          verticalAlign: 'middle',
          fontSize: 22,
          fontFace: 'OpenSansLight',
          lineHeight: 35,
          wordWrap: false,
        },
      },
    }
  }

  set item(itm) {
    this._item = itm.item

    this._colidx = itm.colIdx
  }

  get item() {
    return this._item
  }

  _init() {
    this.moveTitle = false
    // this.tag('CoverBG').alpha = 1
    // this.tag('CoverBG').on('txLoaded', () => {
    // 	this.tag('CoverShadow').patch({
    // 		smooth: {color: [Colors('black').alpha(0.25).get(), {duration: 0.3, timingFunction: 'ease-out'}]}
    // 	});
    // });
    // this.tag('Cover').on('txLoaded', () => {
    // this.tag('CoverBG').alpha = 0
    // this.tag('CoverShadow').patch({
    // 	smooth: {color: [Colors('black').alpha(0.25).get(), {duration: 0.3, timingFunction: 'ease-out'}]}
    // });
    // });
    this.tag('Cover').on('txError', () => {
      this.tag('Cover').src = Utils.asset('images/covers/ImagePlaceHolder.jpg')
    })
    // this.tag("CoverWrapper").transition('scale').on('finish', () => {
    // 	this.tag("MovingTitle").start();
    // });
  }

  _firstActive() {
    this._update()
  }

  _update() {
    this.patch({
      w: 420,
      h: 541,
      CoverWrapper: {
        pivotX: this._colidx === 0 ? 0 : 0.5,
        CoverImageWrapper: {
          Cover: { texture: Img(this._item.imageUrl).cover(420 / 2, 420 / 2) }, // todo resize to original
        },
      },
      Title: { text: { text: this._item.title } },
      // MovingTitle: {title: this._item.title || ''},
      SubTitle: { text: { text: `${this._item.subTitle || ''}` } },
    })
  }

  _focus() {
    this._moveTitle = true

    this.patch({
      CoverWrapper: {
        smooth: {
          scale: [1.05, { duration: 0.3, delay: 0.1, timingFunction: 'ease-out' }],
        },
        CoverImageWrapper: {
          smooth: {
            'shader.strokeColor': [
              Colors('border')
                .alpha(1)
                .get(),
              { duration: 0.4, timingFunction: 'ease-in' },
            ],
          },
        },
      },
      Title: {
        text: { fontSize: 30, fontFace: 'OpenSansBold' },
      },
      SubTitle: {
        text: { fontSize: 25, fontFace: 'OpenSansRegular' },
      },
      // MovingTitle: {smooth: {alpha: [1, {duration: 0.3, delay: 0.3, timingFunction: 'ease-out'}]}}
      // Title: { alpha: 0 },
      // MovingTitle: {alpha: 1}
    })
  }

  _unfocus() {
    this._moveTitle = false

    this.patch({
      CoverWrapper: {
        smooth: {
          scale: [1, { duration: 0.2, delay: 0.1, timingFunction: 'ease-out' }],
        },
        CoverImageWrapper: {
          smooth: {
            'shader.strokeColor': [
              Colors('border')
                .alpha(0)
                .get(),
              { duration: 0.2, timingFunction: 'ease-in' },
            ],
          },
        },
      },
      Title: {
        text: { fontSize: 25, fontFace: 'OpenSansRegular' },
      },
      SubTitle: {
        text: { fontSize: 22, fontFace: 'OpenSansLight' },
      },
      // MovingTitle: {smooth: {alpha: [0, {duration: 0.3, delay: 0.1, timingFunction: 'ease-out'}]}}
      // Title: {alpha: 1},
      // MovingTitle: {alpha: 0}
    })

    // this.tag("MovingTitle").stop();
  }
}
